import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useEffect, useMemo } from "react";
import { useAuthToken } from "capitalrx-shell";

import { getPACaseAPI, financeGetRemittanceAPI } from "@/api";
import { General } from "capitalrx-components-2.0";

type options = Omit<UseQueryOptions, "queryKey">;
export type axiosErrorType = AxiosError<any, any>;

type UseGetHook<Request, Response> = (
  request?: Request,
  options?: options,
) => UseQueryResult<Response, AxiosError>;

const createGetHook = <Request, Response>(
  url: string,
  apiCall: (request: Request, authToken: string) => Promise<Response>,
  defaultOptions?: options,
): UseGetHook<Request, Response> => {

  const query = (
    request,
    options,
  ) => {
    const [authToken] = useAuthToken();
    const appliedOptions = defaultOptions ? defaultOptions : {};
    const showAlert = General.useAlert();

    const call: UseQueryResult<Response, axiosErrorType> = useQuery<Response, axiosErrorType>({
      queryKey: [url, request],
      queryFn: async () => apiCall(request, authToken),
      ...appliedOptions,
      ...options,
    });

    const error = call.error as axiosErrorType;

    useEffect(() => {
      if (call.isError) {
        showAlert({
          message: error.response?.data?.message || error.message,
          type: "error",
          style: "toast",
        });
      }
    }, [call, showAlert]);

    return useMemo(() => call, [call, showAlert]);
  };

  return query;
};


export const useGetPACase = createGetHook("/pa_case/get", getPACaseAPI);

export const useFinanceGetRemittanceAPI = createGetHook("/finance_835/get_remittance", financeGetRemittanceAPI);
